/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WelcomeRouteImport } from './routes/welcome'
import { Route as Subscribe2RouteImport } from './routes/subscribe-2'
import { Route as SubscribeRouteImport } from './routes/subscribe'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as SigningInRouteImport } from './routes/signing-in'
import { Route as SigninRouteImport } from './routes/signin'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as JoinRouteImport } from './routes/join'
import { Route as CheckoutNewRouteImport } from './routes/checkout-new'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as AuthIndexRouteImport } from './routes/_auth.index'
import { Route as AuthWelcomeKitRouteImport } from './routes/_auth.welcome-kit'
import { Route as AuthUserProfileRouteImport } from './routes/_auth.user-profile'
import { Route as AuthTrainingRouteImport } from './routes/_auth.training'
import { Route as AuthToolsRouteImport } from './routes/_auth.tools'
import { Route as AuthToolkitRouteImport } from './routes/_auth.toolkit'
import { Route as AuthSearchRouteImport } from './routes/_auth.search'
import { Route as AuthSavedRouteImport } from './routes/_auth.saved'
import { Route as AuthRequestWelcomeKitRouteImport } from './routes/_auth.request-welcome-kit'
import { Route as AuthReportAScamRouteImport } from './routes/_auth.report-a-scam'
import { Route as AuthPendingInvitationsRouteImport } from './routes/_auth.pending-invitations'
import { Route as AuthOnboardingRouteImport } from './routes/_auth.onboarding'
import { Route as AuthMissionsRouteImport } from './routes/_auth.missions'
import { Route as AuthMessagesRouteImport } from './routes/_auth.messages'
import { Route as AuthLearnRouteImport } from './routes/_auth.learn'
import { Route as AuthInviteRouteImport } from './routes/_auth.invite'
import { Route as AuthHomeLabRouteImport } from './routes/_auth.home-lab'
import { Route as AuthHelpRouteImport } from './routes/_auth.help'
import { Route as AuthFootprintRouteImport } from './routes/_auth.footprint'
import { Route as AuthDataBrokersRouteImport } from './routes/_auth.data-brokers'
import { Route as AuthContactSupportRouteImport } from './routes/_auth.contact-support'
import { Route as AuthCheckoutSuccessRouteImport } from './routes/_auth.checkout-success'
import { Route as AuthCheckoutCancelRouteImport } from './routes/_auth.checkout-cancel'
import { Route as AuthAccountRouteImport } from './routes/_auth.account'
import { Route as AuthSplatRouteImport } from './routes/_auth.$'
import { Route as AuthScamLibraryIndexRouteImport } from './routes/_auth.scam-library.index'
import { Route as AuthDataBreachesIndexRouteImport } from './routes/_auth.data-breaches.index'
import { Route as AuthCoursesIndexRouteImport } from './routes/_auth.courses.index'
import { Route as AuthArticlesIndexRouteImport } from './routes/_auth.articles.index'
import { Route as AuthToolsLinkCheckerRouteImport } from './routes/_auth.tools.link-checker'
import { Route as AuthToolsCharityCheckerRouteImport } from './routes/_auth.tools.charity-checker'
import { Route as AuthScamLibrarySlugRouteImport } from './routes/_auth.scam-library.$slug'
import { Route as AuthMessagesThreadIdRouteImport } from './routes/_auth.messages_.$threadId'
import { Route as AuthLessonsLessonIdRouteImport } from './routes/_auth.lessons.$lessonId'
import { Route as AuthLearningJourneysWhatToDoAfterAScamRouteImport } from './routes/_auth.learning-journeys.what-to-do-after-a-scam'
import { Route as AuthLearningJourneysWhatToDoRouteImport } from './routes/_auth.learning-journeys.what-to-do'
import { Route as AuthLearningJourneysWarningSignsRouteImport } from './routes/_auth.learning-journeys.warning-signs'
import { Route as AuthLearningJourneysScamFundamentalsRouteImport } from './routes/_auth.learning-journeys.scam-fundamentals'
import { Route as AuthLearningJourneysPauseAndVerifyRouteImport } from './routes/_auth.learning-journeys.pause-and-verify'
import { Route as AuthLearningJourneysNewAgeOfScamsRouteImport } from './routes/_auth.learning-journeys.new-age-of-scams'
import { Route as AuthLearningJourneysEmotionalHijackRouteImport } from './routes/_auth.learning-journeys.emotional-hijack'
import { Route as AuthLearningJourneysDigitalSelfDefenceRouteImport } from './routes/_auth.learning-journeys.digital-self-defence'
import { Route as AuthDataBreachesBreachIdRouteImport } from './routes/_auth.data-breaches.$breachId'
import { Route as AuthCoursesCourseIdRouteImport } from './routes/_auth.courses.$courseId'
import { Route as AuthArticlesSlugRouteImport } from './routes/_auth.articles.$slug'
import { Route as AuthToolsScamCheckSituationRouteImport } from './routes/_auth.tools.scam-check.situation'
import { Route as AuthToolsScamCheckProcessingRouteImport } from './routes/_auth.tools.scam-check.processing'
import { Route as AuthToolsScamCheckHistoryRouteImport } from './routes/_auth.tools.scam-check.history'
import { Route as AuthToolsScamCheckCheckIdRouteImport } from './routes/_auth.tools.scam-check.$checkId'

const WelcomeRoute = WelcomeRouteImport.update({
  id: '/welcome',
  path: '/welcome',
  getParentRoute: () => rootRouteImport,
} as any)
const Subscribe2Route = Subscribe2RouteImport.update({
  id: '/subscribe-2',
  path: '/subscribe-2',
  getParentRoute: () => rootRouteImport,
} as any)
const SubscribeRoute = SubscribeRouteImport.update({
  id: '/subscribe',
  path: '/subscribe',
  getParentRoute: () => rootRouteImport,
} as any)
const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const SigningInRoute = SigningInRouteImport.update({
  id: '/signing-in',
  path: '/signing-in',
  getParentRoute: () => rootRouteImport,
} as any)
const SigninRoute = SigninRouteImport.update({
  id: '/signin',
  path: '/signin',
  getParentRoute: () => rootRouteImport,
} as any)
const RegisterRoute = RegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRouteImport,
} as any)
const JoinRoute = JoinRouteImport.update({
  id: '/join',
  path: '/join',
  getParentRoute: () => rootRouteImport,
} as any)
const CheckoutNewRoute = CheckoutNewRouteImport.update({
  id: '/checkout-new',
  path: '/checkout-new',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthIndexRoute = AuthIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthWelcomeKitRoute = AuthWelcomeKitRouteImport.update({
  id: '/welcome-kit',
  path: '/welcome-kit',
  getParentRoute: () => AuthRoute,
} as any)
const AuthUserProfileRoute = AuthUserProfileRouteImport.update({
  id: '/user-profile',
  path: '/user-profile',
  getParentRoute: () => AuthRoute,
} as any)
const AuthTrainingRoute = AuthTrainingRouteImport.update({
  id: '/training',
  path: '/training',
  getParentRoute: () => AuthRoute,
} as any)
const AuthToolsRoute = AuthToolsRouteImport.update({
  id: '/tools',
  path: '/tools',
  getParentRoute: () => AuthRoute,
} as any)
const AuthToolkitRoute = AuthToolkitRouteImport.update({
  id: '/toolkit',
  path: '/toolkit',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSearchRoute = AuthSearchRouteImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSavedRoute = AuthSavedRouteImport.update({
  id: '/saved',
  path: '/saved',
  getParentRoute: () => AuthRoute,
} as any)
const AuthRequestWelcomeKitRoute = AuthRequestWelcomeKitRouteImport.update({
  id: '/request-welcome-kit',
  path: '/request-welcome-kit',
  getParentRoute: () => AuthRoute,
} as any)
const AuthReportAScamRoute = AuthReportAScamRouteImport.update({
  id: '/report-a-scam',
  path: '/report-a-scam',
  getParentRoute: () => AuthRoute,
} as any)
const AuthPendingInvitationsRoute = AuthPendingInvitationsRouteImport.update({
  id: '/pending-invitations',
  path: '/pending-invitations',
  getParentRoute: () => AuthRoute,
} as any)
const AuthOnboardingRoute = AuthOnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => AuthRoute,
} as any)
const AuthMissionsRoute = AuthMissionsRouteImport.update({
  id: '/missions',
  path: '/missions',
  getParentRoute: () => AuthRoute,
} as any)
const AuthMessagesRoute = AuthMessagesRouteImport.update({
  id: '/messages',
  path: '/messages',
  getParentRoute: () => AuthRoute,
} as any)
const AuthLearnRoute = AuthLearnRouteImport.update({
  id: '/learn',
  path: '/learn',
  getParentRoute: () => AuthRoute,
} as any)
const AuthInviteRoute = AuthInviteRouteImport.update({
  id: '/invite',
  path: '/invite',
  getParentRoute: () => AuthRoute,
} as any)
const AuthHomeLabRoute = AuthHomeLabRouteImport.update({
  id: '/home-lab',
  path: '/home-lab',
  getParentRoute: () => AuthRoute,
} as any)
const AuthHelpRoute = AuthHelpRouteImport.update({
  id: '/help',
  path: '/help',
  getParentRoute: () => AuthRoute,
} as any)
const AuthFootprintRoute = AuthFootprintRouteImport.update({
  id: '/footprint',
  path: '/footprint',
  getParentRoute: () => AuthRoute,
} as any)
const AuthDataBrokersRoute = AuthDataBrokersRouteImport.update({
  id: '/data-brokers',
  path: '/data-brokers',
  getParentRoute: () => AuthRoute,
} as any)
const AuthContactSupportRoute = AuthContactSupportRouteImport.update({
  id: '/contact-support',
  path: '/contact-support',
  getParentRoute: () => AuthRoute,
} as any)
const AuthCheckoutSuccessRoute = AuthCheckoutSuccessRouteImport.update({
  id: '/checkout-success',
  path: '/checkout-success',
  getParentRoute: () => AuthRoute,
} as any)
const AuthCheckoutCancelRoute = AuthCheckoutCancelRouteImport.update({
  id: '/checkout-cancel',
  path: '/checkout-cancel',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAccountRoute = AuthAccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSplatRoute = AuthSplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => AuthRoute,
} as any)
const AuthScamLibraryIndexRoute = AuthScamLibraryIndexRouteImport.update({
  id: '/scam-library/',
  path: '/scam-library/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthDataBreachesIndexRoute = AuthDataBreachesIndexRouteImport.update({
  id: '/data-breaches/',
  path: '/data-breaches/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthCoursesIndexRoute = AuthCoursesIndexRouteImport.update({
  id: '/courses/',
  path: '/courses/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthArticlesIndexRoute = AuthArticlesIndexRouteImport.update({
  id: '/articles/',
  path: '/articles/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthToolsLinkCheckerRoute = AuthToolsLinkCheckerRouteImport.update({
  id: '/link-checker',
  path: '/link-checker',
  getParentRoute: () => AuthToolsRoute,
} as any)
const AuthToolsCharityCheckerRoute = AuthToolsCharityCheckerRouteImport.update({
  id: '/charity-checker',
  path: '/charity-checker',
  getParentRoute: () => AuthToolsRoute,
} as any)
const AuthScamLibrarySlugRoute = AuthScamLibrarySlugRouteImport.update({
  id: '/scam-library/$slug',
  path: '/scam-library/$slug',
  getParentRoute: () => AuthRoute,
} as any)
const AuthMessagesThreadIdRoute = AuthMessagesThreadIdRouteImport.update({
  id: '/messages_/$threadId',
  path: '/messages/$threadId',
  getParentRoute: () => AuthRoute,
} as any)
const AuthLessonsLessonIdRoute = AuthLessonsLessonIdRouteImport.update({
  id: '/lessons/$lessonId',
  path: '/lessons/$lessonId',
  getParentRoute: () => AuthRoute,
} as any)
const AuthLearningJourneysWhatToDoAfterAScamRoute =
  AuthLearningJourneysWhatToDoAfterAScamRouteImport.update({
    id: '/learning-journeys/what-to-do-after-a-scam',
    path: '/learning-journeys/what-to-do-after-a-scam',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthLearningJourneysWhatToDoRoute =
  AuthLearningJourneysWhatToDoRouteImport.update({
    id: '/learning-journeys/what-to-do',
    path: '/learning-journeys/what-to-do',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthLearningJourneysWarningSignsRoute =
  AuthLearningJourneysWarningSignsRouteImport.update({
    id: '/learning-journeys/warning-signs',
    path: '/learning-journeys/warning-signs',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthLearningJourneysScamFundamentalsRoute =
  AuthLearningJourneysScamFundamentalsRouteImport.update({
    id: '/learning-journeys/scam-fundamentals',
    path: '/learning-journeys/scam-fundamentals',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthLearningJourneysPauseAndVerifyRoute =
  AuthLearningJourneysPauseAndVerifyRouteImport.update({
    id: '/learning-journeys/pause-and-verify',
    path: '/learning-journeys/pause-and-verify',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthLearningJourneysNewAgeOfScamsRoute =
  AuthLearningJourneysNewAgeOfScamsRouteImport.update({
    id: '/learning-journeys/new-age-of-scams',
    path: '/learning-journeys/new-age-of-scams',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthLearningJourneysEmotionalHijackRoute =
  AuthLearningJourneysEmotionalHijackRouteImport.update({
    id: '/learning-journeys/emotional-hijack',
    path: '/learning-journeys/emotional-hijack',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthLearningJourneysDigitalSelfDefenceRoute =
  AuthLearningJourneysDigitalSelfDefenceRouteImport.update({
    id: '/learning-journeys/digital-self-defence',
    path: '/learning-journeys/digital-self-defence',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthDataBreachesBreachIdRoute =
  AuthDataBreachesBreachIdRouteImport.update({
    id: '/data-breaches/$breachId',
    path: '/data-breaches/$breachId',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthCoursesCourseIdRoute = AuthCoursesCourseIdRouteImport.update({
  id: '/courses/$courseId',
  path: '/courses/$courseId',
  getParentRoute: () => AuthRoute,
} as any)
const AuthArticlesSlugRoute = AuthArticlesSlugRouteImport.update({
  id: '/articles/$slug',
  path: '/articles/$slug',
  getParentRoute: () => AuthRoute,
} as any)
const AuthToolsScamCheckSituationRoute =
  AuthToolsScamCheckSituationRouteImport.update({
    id: '/scam-check/situation',
    path: '/scam-check/situation',
    getParentRoute: () => AuthToolsRoute,
  } as any)
const AuthToolsScamCheckProcessingRoute =
  AuthToolsScamCheckProcessingRouteImport.update({
    id: '/scam-check/processing',
    path: '/scam-check/processing',
    getParentRoute: () => AuthToolsRoute,
  } as any)
const AuthToolsScamCheckHistoryRoute =
  AuthToolsScamCheckHistoryRouteImport.update({
    id: '/scam-check/history',
    path: '/scam-check/history',
    getParentRoute: () => AuthToolsRoute,
  } as any)
const AuthToolsScamCheckCheckIdRoute =
  AuthToolsScamCheckCheckIdRouteImport.update({
    id: '/scam-check/$checkId',
    path: '/scam-check/$checkId',
    getParentRoute: () => AuthToolsRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/checkout-new': typeof CheckoutNewRoute
  '/join': typeof JoinRoute
  '/register': typeof RegisterRoute
  '/signin': typeof SigninRoute
  '/signing-in': typeof SigningInRoute
  '/signup': typeof SignupRoute
  '/subscribe': typeof SubscribeRoute
  '/subscribe-2': typeof Subscribe2Route
  '/welcome': typeof WelcomeRoute
  '/$': typeof AuthSplatRoute
  '/account': typeof AuthAccountRoute
  '/checkout-cancel': typeof AuthCheckoutCancelRoute
  '/checkout-success': typeof AuthCheckoutSuccessRoute
  '/contact-support': typeof AuthContactSupportRoute
  '/data-brokers': typeof AuthDataBrokersRoute
  '/footprint': typeof AuthFootprintRoute
  '/help': typeof AuthHelpRoute
  '/home-lab': typeof AuthHomeLabRoute
  '/invite': typeof AuthInviteRoute
  '/learn': typeof AuthLearnRoute
  '/messages': typeof AuthMessagesRoute
  '/missions': typeof AuthMissionsRoute
  '/onboarding': typeof AuthOnboardingRoute
  '/pending-invitations': typeof AuthPendingInvitationsRoute
  '/report-a-scam': typeof AuthReportAScamRoute
  '/request-welcome-kit': typeof AuthRequestWelcomeKitRoute
  '/saved': typeof AuthSavedRoute
  '/search': typeof AuthSearchRoute
  '/toolkit': typeof AuthToolkitRoute
  '/tools': typeof AuthToolsRouteWithChildren
  '/training': typeof AuthTrainingRoute
  '/user-profile': typeof AuthUserProfileRoute
  '/welcome-kit': typeof AuthWelcomeKitRoute
  '/': typeof AuthIndexRoute
  '/articles/$slug': typeof AuthArticlesSlugRoute
  '/courses/$courseId': typeof AuthCoursesCourseIdRoute
  '/data-breaches/$breachId': typeof AuthDataBreachesBreachIdRoute
  '/learning-journeys/digital-self-defence': typeof AuthLearningJourneysDigitalSelfDefenceRoute
  '/learning-journeys/emotional-hijack': typeof AuthLearningJourneysEmotionalHijackRoute
  '/learning-journeys/new-age-of-scams': typeof AuthLearningJourneysNewAgeOfScamsRoute
  '/learning-journeys/pause-and-verify': typeof AuthLearningJourneysPauseAndVerifyRoute
  '/learning-journeys/scam-fundamentals': typeof AuthLearningJourneysScamFundamentalsRoute
  '/learning-journeys/warning-signs': typeof AuthLearningJourneysWarningSignsRoute
  '/learning-journeys/what-to-do': typeof AuthLearningJourneysWhatToDoRoute
  '/learning-journeys/what-to-do-after-a-scam': typeof AuthLearningJourneysWhatToDoAfterAScamRoute
  '/lessons/$lessonId': typeof AuthLessonsLessonIdRoute
  '/messages/$threadId': typeof AuthMessagesThreadIdRoute
  '/scam-library/$slug': typeof AuthScamLibrarySlugRoute
  '/tools/charity-checker': typeof AuthToolsCharityCheckerRoute
  '/tools/link-checker': typeof AuthToolsLinkCheckerRoute
  '/articles': typeof AuthArticlesIndexRoute
  '/courses': typeof AuthCoursesIndexRoute
  '/data-breaches': typeof AuthDataBreachesIndexRoute
  '/scam-library': typeof AuthScamLibraryIndexRoute
  '/tools/scam-check/$checkId': typeof AuthToolsScamCheckCheckIdRoute
  '/tools/scam-check/history': typeof AuthToolsScamCheckHistoryRoute
  '/tools/scam-check/processing': typeof AuthToolsScamCheckProcessingRoute
  '/tools/scam-check/situation': typeof AuthToolsScamCheckSituationRoute
}
export interface FileRoutesByTo {
  '/checkout-new': typeof CheckoutNewRoute
  '/join': typeof JoinRoute
  '/register': typeof RegisterRoute
  '/signin': typeof SigninRoute
  '/signing-in': typeof SigningInRoute
  '/signup': typeof SignupRoute
  '/subscribe': typeof SubscribeRoute
  '/subscribe-2': typeof Subscribe2Route
  '/welcome': typeof WelcomeRoute
  '/$': typeof AuthSplatRoute
  '/account': typeof AuthAccountRoute
  '/checkout-cancel': typeof AuthCheckoutCancelRoute
  '/checkout-success': typeof AuthCheckoutSuccessRoute
  '/contact-support': typeof AuthContactSupportRoute
  '/data-brokers': typeof AuthDataBrokersRoute
  '/footprint': typeof AuthFootprintRoute
  '/help': typeof AuthHelpRoute
  '/home-lab': typeof AuthHomeLabRoute
  '/invite': typeof AuthInviteRoute
  '/learn': typeof AuthLearnRoute
  '/messages': typeof AuthMessagesRoute
  '/missions': typeof AuthMissionsRoute
  '/onboarding': typeof AuthOnboardingRoute
  '/pending-invitations': typeof AuthPendingInvitationsRoute
  '/report-a-scam': typeof AuthReportAScamRoute
  '/request-welcome-kit': typeof AuthRequestWelcomeKitRoute
  '/saved': typeof AuthSavedRoute
  '/search': typeof AuthSearchRoute
  '/toolkit': typeof AuthToolkitRoute
  '/tools': typeof AuthToolsRouteWithChildren
  '/training': typeof AuthTrainingRoute
  '/user-profile': typeof AuthUserProfileRoute
  '/welcome-kit': typeof AuthWelcomeKitRoute
  '/': typeof AuthIndexRoute
  '/articles/$slug': typeof AuthArticlesSlugRoute
  '/courses/$courseId': typeof AuthCoursesCourseIdRoute
  '/data-breaches/$breachId': typeof AuthDataBreachesBreachIdRoute
  '/learning-journeys/digital-self-defence': typeof AuthLearningJourneysDigitalSelfDefenceRoute
  '/learning-journeys/emotional-hijack': typeof AuthLearningJourneysEmotionalHijackRoute
  '/learning-journeys/new-age-of-scams': typeof AuthLearningJourneysNewAgeOfScamsRoute
  '/learning-journeys/pause-and-verify': typeof AuthLearningJourneysPauseAndVerifyRoute
  '/learning-journeys/scam-fundamentals': typeof AuthLearningJourneysScamFundamentalsRoute
  '/learning-journeys/warning-signs': typeof AuthLearningJourneysWarningSignsRoute
  '/learning-journeys/what-to-do': typeof AuthLearningJourneysWhatToDoRoute
  '/learning-journeys/what-to-do-after-a-scam': typeof AuthLearningJourneysWhatToDoAfterAScamRoute
  '/lessons/$lessonId': typeof AuthLessonsLessonIdRoute
  '/messages/$threadId': typeof AuthMessagesThreadIdRoute
  '/scam-library/$slug': typeof AuthScamLibrarySlugRoute
  '/tools/charity-checker': typeof AuthToolsCharityCheckerRoute
  '/tools/link-checker': typeof AuthToolsLinkCheckerRoute
  '/articles': typeof AuthArticlesIndexRoute
  '/courses': typeof AuthCoursesIndexRoute
  '/data-breaches': typeof AuthDataBreachesIndexRoute
  '/scam-library': typeof AuthScamLibraryIndexRoute
  '/tools/scam-check/$checkId': typeof AuthToolsScamCheckCheckIdRoute
  '/tools/scam-check/history': typeof AuthToolsScamCheckHistoryRoute
  '/tools/scam-check/processing': typeof AuthToolsScamCheckProcessingRoute
  '/tools/scam-check/situation': typeof AuthToolsScamCheckSituationRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_auth': typeof AuthRouteWithChildren
  '/checkout-new': typeof CheckoutNewRoute
  '/join': typeof JoinRoute
  '/register': typeof RegisterRoute
  '/signin': typeof SigninRoute
  '/signing-in': typeof SigningInRoute
  '/signup': typeof SignupRoute
  '/subscribe': typeof SubscribeRoute
  '/subscribe-2': typeof Subscribe2Route
  '/welcome': typeof WelcomeRoute
  '/_auth/$': typeof AuthSplatRoute
  '/_auth/account': typeof AuthAccountRoute
  '/_auth/checkout-cancel': typeof AuthCheckoutCancelRoute
  '/_auth/checkout-success': typeof AuthCheckoutSuccessRoute
  '/_auth/contact-support': typeof AuthContactSupportRoute
  '/_auth/data-brokers': typeof AuthDataBrokersRoute
  '/_auth/footprint': typeof AuthFootprintRoute
  '/_auth/help': typeof AuthHelpRoute
  '/_auth/home-lab': typeof AuthHomeLabRoute
  '/_auth/invite': typeof AuthInviteRoute
  '/_auth/learn': typeof AuthLearnRoute
  '/_auth/messages': typeof AuthMessagesRoute
  '/_auth/missions': typeof AuthMissionsRoute
  '/_auth/onboarding': typeof AuthOnboardingRoute
  '/_auth/pending-invitations': typeof AuthPendingInvitationsRoute
  '/_auth/report-a-scam': typeof AuthReportAScamRoute
  '/_auth/request-welcome-kit': typeof AuthRequestWelcomeKitRoute
  '/_auth/saved': typeof AuthSavedRoute
  '/_auth/search': typeof AuthSearchRoute
  '/_auth/toolkit': typeof AuthToolkitRoute
  '/_auth/tools': typeof AuthToolsRouteWithChildren
  '/_auth/training': typeof AuthTrainingRoute
  '/_auth/user-profile': typeof AuthUserProfileRoute
  '/_auth/welcome-kit': typeof AuthWelcomeKitRoute
  '/_auth/': typeof AuthIndexRoute
  '/_auth/articles/$slug': typeof AuthArticlesSlugRoute
  '/_auth/courses/$courseId': typeof AuthCoursesCourseIdRoute
  '/_auth/data-breaches/$breachId': typeof AuthDataBreachesBreachIdRoute
  '/_auth/learning-journeys/digital-self-defence': typeof AuthLearningJourneysDigitalSelfDefenceRoute
  '/_auth/learning-journeys/emotional-hijack': typeof AuthLearningJourneysEmotionalHijackRoute
  '/_auth/learning-journeys/new-age-of-scams': typeof AuthLearningJourneysNewAgeOfScamsRoute
  '/_auth/learning-journeys/pause-and-verify': typeof AuthLearningJourneysPauseAndVerifyRoute
  '/_auth/learning-journeys/scam-fundamentals': typeof AuthLearningJourneysScamFundamentalsRoute
  '/_auth/learning-journeys/warning-signs': typeof AuthLearningJourneysWarningSignsRoute
  '/_auth/learning-journeys/what-to-do': typeof AuthLearningJourneysWhatToDoRoute
  '/_auth/learning-journeys/what-to-do-after-a-scam': typeof AuthLearningJourneysWhatToDoAfterAScamRoute
  '/_auth/lessons/$lessonId': typeof AuthLessonsLessonIdRoute
  '/_auth/messages_/$threadId': typeof AuthMessagesThreadIdRoute
  '/_auth/scam-library/$slug': typeof AuthScamLibrarySlugRoute
  '/_auth/tools/charity-checker': typeof AuthToolsCharityCheckerRoute
  '/_auth/tools/link-checker': typeof AuthToolsLinkCheckerRoute
  '/_auth/articles/': typeof AuthArticlesIndexRoute
  '/_auth/courses/': typeof AuthCoursesIndexRoute
  '/_auth/data-breaches/': typeof AuthDataBreachesIndexRoute
  '/_auth/scam-library/': typeof AuthScamLibraryIndexRoute
  '/_auth/tools/scam-check/$checkId': typeof AuthToolsScamCheckCheckIdRoute
  '/_auth/tools/scam-check/history': typeof AuthToolsScamCheckHistoryRoute
  '/_auth/tools/scam-check/processing': typeof AuthToolsScamCheckProcessingRoute
  '/_auth/tools/scam-check/situation': typeof AuthToolsScamCheckSituationRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/checkout-new'
    | '/join'
    | '/register'
    | '/signin'
    | '/signing-in'
    | '/signup'
    | '/subscribe'
    | '/subscribe-2'
    | '/welcome'
    | '/$'
    | '/account'
    | '/checkout-cancel'
    | '/checkout-success'
    | '/contact-support'
    | '/data-brokers'
    | '/footprint'
    | '/help'
    | '/home-lab'
    | '/invite'
    | '/learn'
    | '/messages'
    | '/missions'
    | '/onboarding'
    | '/pending-invitations'
    | '/report-a-scam'
    | '/request-welcome-kit'
    | '/saved'
    | '/search'
    | '/toolkit'
    | '/tools'
    | '/training'
    | '/user-profile'
    | '/welcome-kit'
    | '/'
    | '/articles/$slug'
    | '/courses/$courseId'
    | '/data-breaches/$breachId'
    | '/learning-journeys/digital-self-defence'
    | '/learning-journeys/emotional-hijack'
    | '/learning-journeys/new-age-of-scams'
    | '/learning-journeys/pause-and-verify'
    | '/learning-journeys/scam-fundamentals'
    | '/learning-journeys/warning-signs'
    | '/learning-journeys/what-to-do'
    | '/learning-journeys/what-to-do-after-a-scam'
    | '/lessons/$lessonId'
    | '/messages/$threadId'
    | '/scam-library/$slug'
    | '/tools/charity-checker'
    | '/tools/link-checker'
    | '/articles'
    | '/courses'
    | '/data-breaches'
    | '/scam-library'
    | '/tools/scam-check/$checkId'
    | '/tools/scam-check/history'
    | '/tools/scam-check/processing'
    | '/tools/scam-check/situation'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/checkout-new'
    | '/join'
    | '/register'
    | '/signin'
    | '/signing-in'
    | '/signup'
    | '/subscribe'
    | '/subscribe-2'
    | '/welcome'
    | '/$'
    | '/account'
    | '/checkout-cancel'
    | '/checkout-success'
    | '/contact-support'
    | '/data-brokers'
    | '/footprint'
    | '/help'
    | '/home-lab'
    | '/invite'
    | '/learn'
    | '/messages'
    | '/missions'
    | '/onboarding'
    | '/pending-invitations'
    | '/report-a-scam'
    | '/request-welcome-kit'
    | '/saved'
    | '/search'
    | '/toolkit'
    | '/tools'
    | '/training'
    | '/user-profile'
    | '/welcome-kit'
    | '/'
    | '/articles/$slug'
    | '/courses/$courseId'
    | '/data-breaches/$breachId'
    | '/learning-journeys/digital-self-defence'
    | '/learning-journeys/emotional-hijack'
    | '/learning-journeys/new-age-of-scams'
    | '/learning-journeys/pause-and-verify'
    | '/learning-journeys/scam-fundamentals'
    | '/learning-journeys/warning-signs'
    | '/learning-journeys/what-to-do'
    | '/learning-journeys/what-to-do-after-a-scam'
    | '/lessons/$lessonId'
    | '/messages/$threadId'
    | '/scam-library/$slug'
    | '/tools/charity-checker'
    | '/tools/link-checker'
    | '/articles'
    | '/courses'
    | '/data-breaches'
    | '/scam-library'
    | '/tools/scam-check/$checkId'
    | '/tools/scam-check/history'
    | '/tools/scam-check/processing'
    | '/tools/scam-check/situation'
  id:
    | '__root__'
    | '/_auth'
    | '/checkout-new'
    | '/join'
    | '/register'
    | '/signin'
    | '/signing-in'
    | '/signup'
    | '/subscribe'
    | '/subscribe-2'
    | '/welcome'
    | '/_auth/$'
    | '/_auth/account'
    | '/_auth/checkout-cancel'
    | '/_auth/checkout-success'
    | '/_auth/contact-support'
    | '/_auth/data-brokers'
    | '/_auth/footprint'
    | '/_auth/help'
    | '/_auth/home-lab'
    | '/_auth/invite'
    | '/_auth/learn'
    | '/_auth/messages'
    | '/_auth/missions'
    | '/_auth/onboarding'
    | '/_auth/pending-invitations'
    | '/_auth/report-a-scam'
    | '/_auth/request-welcome-kit'
    | '/_auth/saved'
    | '/_auth/search'
    | '/_auth/toolkit'
    | '/_auth/tools'
    | '/_auth/training'
    | '/_auth/user-profile'
    | '/_auth/welcome-kit'
    | '/_auth/'
    | '/_auth/articles/$slug'
    | '/_auth/courses/$courseId'
    | '/_auth/data-breaches/$breachId'
    | '/_auth/learning-journeys/digital-self-defence'
    | '/_auth/learning-journeys/emotional-hijack'
    | '/_auth/learning-journeys/new-age-of-scams'
    | '/_auth/learning-journeys/pause-and-verify'
    | '/_auth/learning-journeys/scam-fundamentals'
    | '/_auth/learning-journeys/warning-signs'
    | '/_auth/learning-journeys/what-to-do'
    | '/_auth/learning-journeys/what-to-do-after-a-scam'
    | '/_auth/lessons/$lessonId'
    | '/_auth/messages_/$threadId'
    | '/_auth/scam-library/$slug'
    | '/_auth/tools/charity-checker'
    | '/_auth/tools/link-checker'
    | '/_auth/articles/'
    | '/_auth/courses/'
    | '/_auth/data-breaches/'
    | '/_auth/scam-library/'
    | '/_auth/tools/scam-check/$checkId'
    | '/_auth/tools/scam-check/history'
    | '/_auth/tools/scam-check/processing'
    | '/_auth/tools/scam-check/situation'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthRoute: typeof AuthRouteWithChildren
  CheckoutNewRoute: typeof CheckoutNewRoute
  JoinRoute: typeof JoinRoute
  RegisterRoute: typeof RegisterRoute
  SigninRoute: typeof SigninRoute
  SigningInRoute: typeof SigningInRoute
  SignupRoute: typeof SignupRoute
  SubscribeRoute: typeof SubscribeRoute
  Subscribe2Route: typeof Subscribe2Route
  WelcomeRoute: typeof WelcomeRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/welcome': {
      id: '/welcome'
      path: '/welcome'
      fullPath: '/welcome'
      preLoaderRoute: typeof WelcomeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/subscribe-2': {
      id: '/subscribe-2'
      path: '/subscribe-2'
      fullPath: '/subscribe-2'
      preLoaderRoute: typeof Subscribe2RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/subscribe': {
      id: '/subscribe'
      path: '/subscribe'
      fullPath: '/subscribe'
      preLoaderRoute: typeof SubscribeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signing-in': {
      id: '/signing-in'
      path: '/signing-in'
      fullPath: '/signing-in'
      preLoaderRoute: typeof SigningInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signin': {
      id: '/signin'
      path: '/signin'
      fullPath: '/signin'
      preLoaderRoute: typeof SigninRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/register': {
      id: '/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof RegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/join': {
      id: '/join'
      path: '/join'
      fullPath: '/join'
      preLoaderRoute: typeof JoinRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/checkout-new': {
      id: '/checkout-new'
      path: '/checkout-new'
      fullPath: '/checkout-new'
      preLoaderRoute: typeof CheckoutNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/': {
      id: '/_auth/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/welcome-kit': {
      id: '/_auth/welcome-kit'
      path: '/welcome-kit'
      fullPath: '/welcome-kit'
      preLoaderRoute: typeof AuthWelcomeKitRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/user-profile': {
      id: '/_auth/user-profile'
      path: '/user-profile'
      fullPath: '/user-profile'
      preLoaderRoute: typeof AuthUserProfileRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/training': {
      id: '/_auth/training'
      path: '/training'
      fullPath: '/training'
      preLoaderRoute: typeof AuthTrainingRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/tools': {
      id: '/_auth/tools'
      path: '/tools'
      fullPath: '/tools'
      preLoaderRoute: typeof AuthToolsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/toolkit': {
      id: '/_auth/toolkit'
      path: '/toolkit'
      fullPath: '/toolkit'
      preLoaderRoute: typeof AuthToolkitRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/search': {
      id: '/_auth/search'
      path: '/search'
      fullPath: '/search'
      preLoaderRoute: typeof AuthSearchRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/saved': {
      id: '/_auth/saved'
      path: '/saved'
      fullPath: '/saved'
      preLoaderRoute: typeof AuthSavedRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/request-welcome-kit': {
      id: '/_auth/request-welcome-kit'
      path: '/request-welcome-kit'
      fullPath: '/request-welcome-kit'
      preLoaderRoute: typeof AuthRequestWelcomeKitRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/report-a-scam': {
      id: '/_auth/report-a-scam'
      path: '/report-a-scam'
      fullPath: '/report-a-scam'
      preLoaderRoute: typeof AuthReportAScamRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/pending-invitations': {
      id: '/_auth/pending-invitations'
      path: '/pending-invitations'
      fullPath: '/pending-invitations'
      preLoaderRoute: typeof AuthPendingInvitationsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/onboarding': {
      id: '/_auth/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof AuthOnboardingRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/missions': {
      id: '/_auth/missions'
      path: '/missions'
      fullPath: '/missions'
      preLoaderRoute: typeof AuthMissionsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/messages': {
      id: '/_auth/messages'
      path: '/messages'
      fullPath: '/messages'
      preLoaderRoute: typeof AuthMessagesRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/learn': {
      id: '/_auth/learn'
      path: '/learn'
      fullPath: '/learn'
      preLoaderRoute: typeof AuthLearnRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/invite': {
      id: '/_auth/invite'
      path: '/invite'
      fullPath: '/invite'
      preLoaderRoute: typeof AuthInviteRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/home-lab': {
      id: '/_auth/home-lab'
      path: '/home-lab'
      fullPath: '/home-lab'
      preLoaderRoute: typeof AuthHomeLabRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/help': {
      id: '/_auth/help'
      path: '/help'
      fullPath: '/help'
      preLoaderRoute: typeof AuthHelpRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/footprint': {
      id: '/_auth/footprint'
      path: '/footprint'
      fullPath: '/footprint'
      preLoaderRoute: typeof AuthFootprintRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/data-brokers': {
      id: '/_auth/data-brokers'
      path: '/data-brokers'
      fullPath: '/data-brokers'
      preLoaderRoute: typeof AuthDataBrokersRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/contact-support': {
      id: '/_auth/contact-support'
      path: '/contact-support'
      fullPath: '/contact-support'
      preLoaderRoute: typeof AuthContactSupportRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/checkout-success': {
      id: '/_auth/checkout-success'
      path: '/checkout-success'
      fullPath: '/checkout-success'
      preLoaderRoute: typeof AuthCheckoutSuccessRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/checkout-cancel': {
      id: '/_auth/checkout-cancel'
      path: '/checkout-cancel'
      fullPath: '/checkout-cancel'
      preLoaderRoute: typeof AuthCheckoutCancelRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/account': {
      id: '/_auth/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AuthAccountRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/$': {
      id: '/_auth/$'
      path: '/$'
      fullPath: '/$'
      preLoaderRoute: typeof AuthSplatRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/scam-library/': {
      id: '/_auth/scam-library/'
      path: '/scam-library'
      fullPath: '/scam-library'
      preLoaderRoute: typeof AuthScamLibraryIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/data-breaches/': {
      id: '/_auth/data-breaches/'
      path: '/data-breaches'
      fullPath: '/data-breaches'
      preLoaderRoute: typeof AuthDataBreachesIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/courses/': {
      id: '/_auth/courses/'
      path: '/courses'
      fullPath: '/courses'
      preLoaderRoute: typeof AuthCoursesIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/articles/': {
      id: '/_auth/articles/'
      path: '/articles'
      fullPath: '/articles'
      preLoaderRoute: typeof AuthArticlesIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/tools/link-checker': {
      id: '/_auth/tools/link-checker'
      path: '/link-checker'
      fullPath: '/tools/link-checker'
      preLoaderRoute: typeof AuthToolsLinkCheckerRouteImport
      parentRoute: typeof AuthToolsRoute
    }
    '/_auth/tools/charity-checker': {
      id: '/_auth/tools/charity-checker'
      path: '/charity-checker'
      fullPath: '/tools/charity-checker'
      preLoaderRoute: typeof AuthToolsCharityCheckerRouteImport
      parentRoute: typeof AuthToolsRoute
    }
    '/_auth/scam-library/$slug': {
      id: '/_auth/scam-library/$slug'
      path: '/scam-library/$slug'
      fullPath: '/scam-library/$slug'
      preLoaderRoute: typeof AuthScamLibrarySlugRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/messages_/$threadId': {
      id: '/_auth/messages_/$threadId'
      path: '/messages/$threadId'
      fullPath: '/messages/$threadId'
      preLoaderRoute: typeof AuthMessagesThreadIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/lessons/$lessonId': {
      id: '/_auth/lessons/$lessonId'
      path: '/lessons/$lessonId'
      fullPath: '/lessons/$lessonId'
      preLoaderRoute: typeof AuthLessonsLessonIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/learning-journeys/what-to-do-after-a-scam': {
      id: '/_auth/learning-journeys/what-to-do-after-a-scam'
      path: '/learning-journeys/what-to-do-after-a-scam'
      fullPath: '/learning-journeys/what-to-do-after-a-scam'
      preLoaderRoute: typeof AuthLearningJourneysWhatToDoAfterAScamRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/learning-journeys/what-to-do': {
      id: '/_auth/learning-journeys/what-to-do'
      path: '/learning-journeys/what-to-do'
      fullPath: '/learning-journeys/what-to-do'
      preLoaderRoute: typeof AuthLearningJourneysWhatToDoRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/learning-journeys/warning-signs': {
      id: '/_auth/learning-journeys/warning-signs'
      path: '/learning-journeys/warning-signs'
      fullPath: '/learning-journeys/warning-signs'
      preLoaderRoute: typeof AuthLearningJourneysWarningSignsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/learning-journeys/scam-fundamentals': {
      id: '/_auth/learning-journeys/scam-fundamentals'
      path: '/learning-journeys/scam-fundamentals'
      fullPath: '/learning-journeys/scam-fundamentals'
      preLoaderRoute: typeof AuthLearningJourneysScamFundamentalsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/learning-journeys/pause-and-verify': {
      id: '/_auth/learning-journeys/pause-and-verify'
      path: '/learning-journeys/pause-and-verify'
      fullPath: '/learning-journeys/pause-and-verify'
      preLoaderRoute: typeof AuthLearningJourneysPauseAndVerifyRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/learning-journeys/new-age-of-scams': {
      id: '/_auth/learning-journeys/new-age-of-scams'
      path: '/learning-journeys/new-age-of-scams'
      fullPath: '/learning-journeys/new-age-of-scams'
      preLoaderRoute: typeof AuthLearningJourneysNewAgeOfScamsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/learning-journeys/emotional-hijack': {
      id: '/_auth/learning-journeys/emotional-hijack'
      path: '/learning-journeys/emotional-hijack'
      fullPath: '/learning-journeys/emotional-hijack'
      preLoaderRoute: typeof AuthLearningJourneysEmotionalHijackRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/learning-journeys/digital-self-defence': {
      id: '/_auth/learning-journeys/digital-self-defence'
      path: '/learning-journeys/digital-self-defence'
      fullPath: '/learning-journeys/digital-self-defence'
      preLoaderRoute: typeof AuthLearningJourneysDigitalSelfDefenceRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/data-breaches/$breachId': {
      id: '/_auth/data-breaches/$breachId'
      path: '/data-breaches/$breachId'
      fullPath: '/data-breaches/$breachId'
      preLoaderRoute: typeof AuthDataBreachesBreachIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/courses/$courseId': {
      id: '/_auth/courses/$courseId'
      path: '/courses/$courseId'
      fullPath: '/courses/$courseId'
      preLoaderRoute: typeof AuthCoursesCourseIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/articles/$slug': {
      id: '/_auth/articles/$slug'
      path: '/articles/$slug'
      fullPath: '/articles/$slug'
      preLoaderRoute: typeof AuthArticlesSlugRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/tools/scam-check/situation': {
      id: '/_auth/tools/scam-check/situation'
      path: '/scam-check/situation'
      fullPath: '/tools/scam-check/situation'
      preLoaderRoute: typeof AuthToolsScamCheckSituationRouteImport
      parentRoute: typeof AuthToolsRoute
    }
    '/_auth/tools/scam-check/processing': {
      id: '/_auth/tools/scam-check/processing'
      path: '/scam-check/processing'
      fullPath: '/tools/scam-check/processing'
      preLoaderRoute: typeof AuthToolsScamCheckProcessingRouteImport
      parentRoute: typeof AuthToolsRoute
    }
    '/_auth/tools/scam-check/history': {
      id: '/_auth/tools/scam-check/history'
      path: '/scam-check/history'
      fullPath: '/tools/scam-check/history'
      preLoaderRoute: typeof AuthToolsScamCheckHistoryRouteImport
      parentRoute: typeof AuthToolsRoute
    }
    '/_auth/tools/scam-check/$checkId': {
      id: '/_auth/tools/scam-check/$checkId'
      path: '/scam-check/$checkId'
      fullPath: '/tools/scam-check/$checkId'
      preLoaderRoute: typeof AuthToolsScamCheckCheckIdRouteImport
      parentRoute: typeof AuthToolsRoute
    }
  }
}

interface AuthToolsRouteChildren {
  AuthToolsCharityCheckerRoute: typeof AuthToolsCharityCheckerRoute
  AuthToolsLinkCheckerRoute: typeof AuthToolsLinkCheckerRoute
  AuthToolsScamCheckCheckIdRoute: typeof AuthToolsScamCheckCheckIdRoute
  AuthToolsScamCheckHistoryRoute: typeof AuthToolsScamCheckHistoryRoute
  AuthToolsScamCheckProcessingRoute: typeof AuthToolsScamCheckProcessingRoute
  AuthToolsScamCheckSituationRoute: typeof AuthToolsScamCheckSituationRoute
}

const AuthToolsRouteChildren: AuthToolsRouteChildren = {
  AuthToolsCharityCheckerRoute: AuthToolsCharityCheckerRoute,
  AuthToolsLinkCheckerRoute: AuthToolsLinkCheckerRoute,
  AuthToolsScamCheckCheckIdRoute: AuthToolsScamCheckCheckIdRoute,
  AuthToolsScamCheckHistoryRoute: AuthToolsScamCheckHistoryRoute,
  AuthToolsScamCheckProcessingRoute: AuthToolsScamCheckProcessingRoute,
  AuthToolsScamCheckSituationRoute: AuthToolsScamCheckSituationRoute,
}

const AuthToolsRouteWithChildren = AuthToolsRoute._addFileChildren(
  AuthToolsRouteChildren,
)

interface AuthRouteChildren {
  AuthSplatRoute: typeof AuthSplatRoute
  AuthAccountRoute: typeof AuthAccountRoute
  AuthCheckoutCancelRoute: typeof AuthCheckoutCancelRoute
  AuthCheckoutSuccessRoute: typeof AuthCheckoutSuccessRoute
  AuthContactSupportRoute: typeof AuthContactSupportRoute
  AuthDataBrokersRoute: typeof AuthDataBrokersRoute
  AuthFootprintRoute: typeof AuthFootprintRoute
  AuthHelpRoute: typeof AuthHelpRoute
  AuthHomeLabRoute: typeof AuthHomeLabRoute
  AuthInviteRoute: typeof AuthInviteRoute
  AuthLearnRoute: typeof AuthLearnRoute
  AuthMessagesRoute: typeof AuthMessagesRoute
  AuthMissionsRoute: typeof AuthMissionsRoute
  AuthOnboardingRoute: typeof AuthOnboardingRoute
  AuthPendingInvitationsRoute: typeof AuthPendingInvitationsRoute
  AuthReportAScamRoute: typeof AuthReportAScamRoute
  AuthRequestWelcomeKitRoute: typeof AuthRequestWelcomeKitRoute
  AuthSavedRoute: typeof AuthSavedRoute
  AuthSearchRoute: typeof AuthSearchRoute
  AuthToolkitRoute: typeof AuthToolkitRoute
  AuthToolsRoute: typeof AuthToolsRouteWithChildren
  AuthTrainingRoute: typeof AuthTrainingRoute
  AuthUserProfileRoute: typeof AuthUserProfileRoute
  AuthWelcomeKitRoute: typeof AuthWelcomeKitRoute
  AuthIndexRoute: typeof AuthIndexRoute
  AuthArticlesSlugRoute: typeof AuthArticlesSlugRoute
  AuthCoursesCourseIdRoute: typeof AuthCoursesCourseIdRoute
  AuthDataBreachesBreachIdRoute: typeof AuthDataBreachesBreachIdRoute
  AuthLearningJourneysDigitalSelfDefenceRoute: typeof AuthLearningJourneysDigitalSelfDefenceRoute
  AuthLearningJourneysEmotionalHijackRoute: typeof AuthLearningJourneysEmotionalHijackRoute
  AuthLearningJourneysNewAgeOfScamsRoute: typeof AuthLearningJourneysNewAgeOfScamsRoute
  AuthLearningJourneysPauseAndVerifyRoute: typeof AuthLearningJourneysPauseAndVerifyRoute
  AuthLearningJourneysScamFundamentalsRoute: typeof AuthLearningJourneysScamFundamentalsRoute
  AuthLearningJourneysWarningSignsRoute: typeof AuthLearningJourneysWarningSignsRoute
  AuthLearningJourneysWhatToDoRoute: typeof AuthLearningJourneysWhatToDoRoute
  AuthLearningJourneysWhatToDoAfterAScamRoute: typeof AuthLearningJourneysWhatToDoAfterAScamRoute
  AuthLessonsLessonIdRoute: typeof AuthLessonsLessonIdRoute
  AuthMessagesThreadIdRoute: typeof AuthMessagesThreadIdRoute
  AuthScamLibrarySlugRoute: typeof AuthScamLibrarySlugRoute
  AuthArticlesIndexRoute: typeof AuthArticlesIndexRoute
  AuthCoursesIndexRoute: typeof AuthCoursesIndexRoute
  AuthDataBreachesIndexRoute: typeof AuthDataBreachesIndexRoute
  AuthScamLibraryIndexRoute: typeof AuthScamLibraryIndexRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthSplatRoute: AuthSplatRoute,
  AuthAccountRoute: AuthAccountRoute,
  AuthCheckoutCancelRoute: AuthCheckoutCancelRoute,
  AuthCheckoutSuccessRoute: AuthCheckoutSuccessRoute,
  AuthContactSupportRoute: AuthContactSupportRoute,
  AuthDataBrokersRoute: AuthDataBrokersRoute,
  AuthFootprintRoute: AuthFootprintRoute,
  AuthHelpRoute: AuthHelpRoute,
  AuthHomeLabRoute: AuthHomeLabRoute,
  AuthInviteRoute: AuthInviteRoute,
  AuthLearnRoute: AuthLearnRoute,
  AuthMessagesRoute: AuthMessagesRoute,
  AuthMissionsRoute: AuthMissionsRoute,
  AuthOnboardingRoute: AuthOnboardingRoute,
  AuthPendingInvitationsRoute: AuthPendingInvitationsRoute,
  AuthReportAScamRoute: AuthReportAScamRoute,
  AuthRequestWelcomeKitRoute: AuthRequestWelcomeKitRoute,
  AuthSavedRoute: AuthSavedRoute,
  AuthSearchRoute: AuthSearchRoute,
  AuthToolkitRoute: AuthToolkitRoute,
  AuthToolsRoute: AuthToolsRouteWithChildren,
  AuthTrainingRoute: AuthTrainingRoute,
  AuthUserProfileRoute: AuthUserProfileRoute,
  AuthWelcomeKitRoute: AuthWelcomeKitRoute,
  AuthIndexRoute: AuthIndexRoute,
  AuthArticlesSlugRoute: AuthArticlesSlugRoute,
  AuthCoursesCourseIdRoute: AuthCoursesCourseIdRoute,
  AuthDataBreachesBreachIdRoute: AuthDataBreachesBreachIdRoute,
  AuthLearningJourneysDigitalSelfDefenceRoute:
    AuthLearningJourneysDigitalSelfDefenceRoute,
  AuthLearningJourneysEmotionalHijackRoute:
    AuthLearningJourneysEmotionalHijackRoute,
  AuthLearningJourneysNewAgeOfScamsRoute:
    AuthLearningJourneysNewAgeOfScamsRoute,
  AuthLearningJourneysPauseAndVerifyRoute:
    AuthLearningJourneysPauseAndVerifyRoute,
  AuthLearningJourneysScamFundamentalsRoute:
    AuthLearningJourneysScamFundamentalsRoute,
  AuthLearningJourneysWarningSignsRoute: AuthLearningJourneysWarningSignsRoute,
  AuthLearningJourneysWhatToDoRoute: AuthLearningJourneysWhatToDoRoute,
  AuthLearningJourneysWhatToDoAfterAScamRoute:
    AuthLearningJourneysWhatToDoAfterAScamRoute,
  AuthLessonsLessonIdRoute: AuthLessonsLessonIdRoute,
  AuthMessagesThreadIdRoute: AuthMessagesThreadIdRoute,
  AuthScamLibrarySlugRoute: AuthScamLibrarySlugRoute,
  AuthArticlesIndexRoute: AuthArticlesIndexRoute,
  AuthCoursesIndexRoute: AuthCoursesIndexRoute,
  AuthDataBreachesIndexRoute: AuthDataBreachesIndexRoute,
  AuthScamLibraryIndexRoute: AuthScamLibraryIndexRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthRoute: AuthRouteWithChildren,
  CheckoutNewRoute: CheckoutNewRoute,
  JoinRoute: JoinRoute,
  RegisterRoute: RegisterRoute,
  SigninRoute: SigninRoute,
  SigningInRoute: SigningInRoute,
  SignupRoute: SignupRoute,
  SubscribeRoute: SubscribeRoute,
  Subscribe2Route: Subscribe2Route,
  WelcomeRoute: WelcomeRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
